import GLightbox from 'glightbox/src/js/glightbox.js';

export class themeGlightbox {
	constructor() {
		this.init();
	}

	init() {
		const galleries = document.querySelectorAll('.block--gallery');
		function initGallery(galleryElement, index) {
			if (index === 0 || index > 0) {
				// Initialize GLightbox for this gallery
				GLightbox({
					selector: '.block--gallery .gallery-item',
					touchNavigation: true,
					type: 'image',
					skin: 'clean',
					loop: true,
					preload: true,
					autoplayVideos: false,
					openEffect: 'zoom',
					closeEffect: 'zoom',
					draggable: true,
					plyr: {
						css: 'https://cdn.plyr.io/3.6.12/plyr.css',
					},
				});

				// Make GLightbox globally available for the block's view.js script
				window.GLightbox = GLightbox;
			}
		}
		galleries.forEach(initGallery);
	}
}
